@if (platformAppContext.activeApp$ | async; as activeApp) {
  <button
    class="app-switcher-trigger"
    (click)="layoutActions.showAppMenu()"
    >
    <span class="app-switcher-trigger__name">{{ activeApp.name || 'Apps' }}</span>
    <i eIcon icon="chevron-down" class="app-switcher-trigger__chevron"></i>
  </button>
}

@if (!(platformAppContext.activeApp$ | async)) {
  <button
    class="app-switcher-trigger app-switcher-trigger--empty"
    (click)="layoutActions.showAppMenu()"
    >
    <span class="app-switcher-trigger__name">Apps</span>
    <i eIcon icon="chevron-down" class="app-switcher-trigger__chevron"></i>
  </button>
}

<ng-template #menuDialog>
  <div class="app-menu-panel" (click)="closeAppMenu()">
    <div class="app-menu-panel__header" (click)="$event.stopPropagation()">
      <div class="app-menu-panel__brand">
        <span class="app-menu-panel__title">Mechanics in Motion</span>
        <span class="app-menu-panel__subtitle">Empowerment through awareness</span>
      </div>
      <button class="app-menu-panel__close" (click)="closeAppMenu()" title="Sluit menu">
        <i eIcon icon="times"></i>
      </button>
    </div>

    <div class="app-menu-panel__search" (click)="$event.stopPropagation()">
      <e-search-input
        border
        ngDefaultControl
        (searchClick)="$event.stopPropagation()"
        (click)="$event.stopPropagation()"
        (focus)="$event.stopPropagation()"
        [ngModel]="appSearchText$ | async"
        (ngModelChange)="appSearchText$.next($event)"
        [autoFocus]="autoFocusOnSearch()"
      ></e-search-input>
    </div>

    <div class="app-menu-panel__body">
      @if ((allApps$ | async)?.length) {
        <div class="app-menu-section">
          <div class="app-menu-section__header">Your apps</div>
          <div class="app-menu-list">
            @for (app of allApps$ | async; track app) {
              <egi-app-card
                (click)="$event.stopPropagation(); selectApp(app)"
                [app]="app"
                [active]="(isActiveApp$(app) | async) === true"
              ></egi-app-card>
            }
          </div>
        </div>
      }

      <div class="app-menu-section">
        <div class="app-menu-section__header">Projects taking root</div>
        <div class="app-menu-coming-soon-list">
          <div class="app-menu-coming-soon">
            <div class="app-menu-coming-soon__row">
              <div class="app-menu-coming-soon__icon">
                <i eIcon icon="wind"></i>
              </div>
              <div class="app-menu-coming-soon__text">
                <div class="app-menu-coming-soon__title">The Breathing Mechanic</div>
                <div class="app-menu-coming-soon__subtitle">
                  rediscover the art of breathing less
                </div>
                <div class="app-menu-coming-soon__description">
                  CO2, awareness & <br />the mechanics of your most fundamental movement
                </div>
              </div>
            </div>
          </div>

          <div class="app-menu-coming-soon">
            <div class="app-menu-coming-soon__row">
              <div class="app-menu-coming-soon__icon">
                <i eIcon icon="child"></i>
              </div>
              <div class="app-menu-coming-soon__text">
                <div class="app-menu-coming-soon__title">Zo zit je in mekaar</div>
                <div class="app-menu-coming-soon__subtitle">
                  Human Design voor kinderen & ouders
                </div>
              </div>
            </div>
          </div>

          <div class="app-menu-coming-soon">
            <div class="app-menu-coming-soon__row">
              <div class="app-menu-coming-soon__icon">
                <i eIcon icon="feather-alt"></i>
              </div>
              <div class="app-menu-coming-soon__text">
                <div class="app-menu-coming-soon__title">Blog</div>
                <div class="app-menu-coming-soon__subtitle">A 6th line transmission</div>
              </div>
            </div>
          </div>
        </div>
        <div class="app-menu-coming-soon__caption">
          We're building more tools for your journey
        </div>
      </div>
    </div>

    <div class="app-menu-panel__footer" (click)="$event.stopPropagation()">
      <button
        class="app-menu-panel__btn-secondary"
        (click)="restartApplication()"
        title="Opnieuw opstarten"
        >
        <i eIcon icon="undo"></i>
        <span>Herstart</span>
      </button>
      <span class="app-menu-panel__version" [title]="'v' + appService.version">
        v{{ appService.version }}
      </span>
      <button
        class="app-menu-panel__btn-secondary"
        (click)="closeAppMenu()"
        title="Menu sluiten"
        >
        <i eIcon icon="times"></i>
        <span>Sluiten</span>
      </button>
    </div>
  </div>
</ng-template>
